import { z } from 'zod'

import { ExerciseApi } from '../api'
import { getApiConfig } from './api-config'
import { nullablePositiveNumberSchema, yearWeekSchema } from './dal-utils'

export const exerciseStatsSchema = z.object({
  streak: z.number().min(0),
  longestStreak: nullablePositiveNumberSchema,
})

export const dashboardInfoSchema = z.object({
  streak: z.number(),
  progress: nullablePositiveNumberSchema,
  goal: z.number().min(0),
  total: z.number().min(0),
  totalTime: z.number().min(0), // The amount of time spent exercising in the past 30 days
})

export async function fetchExerciseStats() {
  const exerciseApi = new ExerciseApi(getApiConfig())
  const dto = await exerciseApi.apiExerciseDashboardStreaksGet()

  return exerciseStatsSchema.parse({
    streak: dto.streak,
    longestStreak: dto.longestStreak,
  })
}

export async function fetchDashboardInfo(yearWeek: string) {
  const exerciseApi = new ExerciseApi(getApiConfig())
  const parsedYearWeek = yearWeekSchema.parse(yearWeek)
  const dto = await exerciseApi.apiExerciseDashboardInfoGet({
    yearWeek: parsedYearWeek,
  })

  return dashboardInfoSchema.parse({
    streak: dto.streak,
    progress: dto.progress,
    goal: dto.goal,
    total: dto.total,
    totalTime: dto.totalTime,
  })
}
